<template>
  <router-link
    :to="{ name: 'pages_profile' }"
    class="d-flex align-items-center dropdown-user-link text-decoration-none"
  >
    <b-avatar
      size="40"
      :src="require('@/assets/images/avatars/AvatarImage.png')"
      variant="light-primary"
      badge
      class="badge-minimal"
      badge-variant="success"
    >
      <!-- <feather-icon
        v-if="!userData.fullName"
        icon="UserIcon"
        size="22"
      /> -->
    </b-avatar>
    <div class="d-sm-flex d-none user-nav flex-column ml-1">
      <div class="d-flex align-items-center">
        <p class="user-name font-weight-bolder mb-0 mr-50">
          {{ userName }}
        </p>
        <user-badge />
      </div>
      <span v-if="subtitle">{{ subtitle }}</span>
      <span v-else>AUC</span>
    </div>
  </router-link>
</template>

<script>
import {
  BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { mapGetters } from 'vuex'
import UserBadge from './UserBadge.vue'

export default {
  components: {
    BAvatar,
    UserBadge,
  },
  props: {
    title: String,
    subtitle: String,
  },
  data() {
    return {
      avatarText,
    }
  },
  computed: {
    ...mapGetters({
      user: 'users/user',
    }),
    userData() {
      return JSON.parse(localStorage.getItem('userData') || '{}')
    },
    userName() {
      if (this.title) return this.title
      const currentUser = (this.user && this.user.fname) ? this.user : this.userData
      return currentUser && currentUser.fname ? `${currentUser.fname} ${currentUser.lname || ''}`.trim() : 'Asia Emad'
    },
  },
}
</script>
